/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TipoConsumoArticolo } from './tipo-consumo-articolo';


export interface TransazioneVoucherArticoloSpendForm { 
    codice_voucher: string;
    id_negozio: string;
    id_articolo_pratica: string;
    tipo: TipoConsumoArticolo;
    version: number;
}



